"use client";

import { useEffect, useState } from "react";
import InaccessabilityPopup from "./inaccessabilityPopup";

const scale = 0.3;
const hSize = 603 * scale;
const wSize = 1583 * scale;

export default function Glasses({ setNudgeOpen, size = 200 }: {setNudgeOpen: (a: boolean)=>void, size: number }) {
  const [cursor, setCursor] = useState({ x: 0, y: 0 });
  const [active, setActive] = useState(false);

  useEffect(() => {
    const move = (e:any) => setCursor({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);


  return (
    <div>
      {active && (
        <>
        <div
          className="fixed inset-0 backdrop-blur-lg z-[9999] pointer-events-none"
          style={{
            maskImage: `url('/lens.png'), linear-gradient(#000, #000)`,
            maskPosition: `${cursor.x - wSize / 2}px ${cursor.y - hSize / 2}px, 0 0`,
            maskSize: `${wSize}px ${hSize}px, 100% 100%`,
            maskRepeat: "no-repeat",
            WebkitMaskComposite: "destination-out", 
            maskComposite: "exclude",
          }}
        />

        <img src="/glasses.png" alt="Glasses" className="fixed z-[10001] pointer-events-none" style={{ left: cursor.x - wSize / 2, top: cursor.y - hSize / 2, width: wSize, height: hSize }} />
        </>
      )}


      <div className="fixed  z-[10000] pointer-events-auto">
        <InaccessabilityPopup setGlassesEnabled={setActive} setNudgeOpen={setNudgeOpen} />
      </div>
    </div>
  );
}